// extracted by mini-css-extract-plugin
export default {"heading":"ExpertStudentPII_heading__xVj4I","exportButton":"ExpertStudentPII_exportButton__nt8R1"};